import { AuthEmployeeResponseData, OrganizationTypeEnum } from "schema"

const organizationTypesWithSubscription = [
  OrganizationTypeEnum.Client,
  OrganizationTypeEnum.Freemium,
]

export function canSeeSubscription(employee?: AuthEmployeeResponseData) {
  if (!employee) {
    return false
  }

  const organizationHasSubscription = organizationTypesWithSubscription.includes(
    employee.organization.type,
  )

  return organizationHasSubscription && employee.organization.showCredits
}
